import { IApartment } from '@wohnsinn/ws-ts-lib';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { onSnapshot } from 'firebase/firestore';
import { wohnsinnServices } from '../../App';

export interface IUseApartmentProps {
  apartment: IApartment;
  isLoading: boolean;
}

const useApartment = (apartmentIdFromProps?: string): IUseApartmentProps => {
  let { apartmentId } = useParams<{ apartmentId: string }>();
  const { apartmentService } = wohnsinnServices;
  const [apartment, setApartment] = useState<IApartment>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  if (apartmentIdFromProps) {
    apartmentId = apartmentIdFromProps;
  }

  const fetchApartment = async () => {
    setIsLoading(true);
    onSnapshot(
      apartmentService.getApartmentRef(apartmentId),
      (apartmentListSnap) => {
        const apartment = apartmentListSnap.docs.map((doc) => doc.data())[0];
        setApartment(apartment);
        setIsLoading(false);
      },
      (err) => console.error('error on useApartmentHook: ', err)
    );
  };

  useEffect(() => {
    if (apartmentId) {
      fetchApartment();
    } else {
      setIsLoading(false);
    }
  }, [apartmentId]);

  return { apartment, isLoading };
};

export default useApartment;
